import { DashboardColumn } from '~/app/constants/defaultColumns';
import { TherapyJobStatus } from '~/app/enums/TherapyJobStatus';
import { TherapyJobV2 } from '~/app/models/TherapyJobV2';
import { columnNameByStatus } from '../getColumnByStatus';

export const jobNotResolved = (tj: Partial<TherapyJobV2>) => {
  if (!tj) {
    console.warn('TherapyJob is undefined. Cannot determine if job is resolved or not.');
    return null;
  }

  const notInCompletedCol = columnNameByStatus(tj?.status) !== DashboardColumn.COMPLETED;
  const notInHistory = tj.status !== TherapyJobStatus.IN_HISTORY;
  const notInAbortion = !tj.abortionTriggered;

  return notInCompletedCol && notInHistory && notInAbortion;
};
